export default __webpack_public_path__ + "static/media/ic_avt_40_1.d4559982.svg";